import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { getGuestCart, clearGuestCart } from "./handleGuestCart";
import { shopid, getUserId } from "./url";
import { addToCart, fetchCart } from "../../node_modules/shops-query/src/modules/cart/index.js";


export const migrateGuestCartToUserCart = async (userId) => {
  const guestCart = getGuestCart();

  if (!guestCart || guestCart.length === 0) {
    return;
  }

  try {
    const userCart = await fetchCart(shopid, Number(userId));

    for (const item of guestCart) {
      const isAlreadyInCart = userCart.some(
        (cartItem) => cartItem.productId === item.productId
      );

      if (!isAlreadyInCart) {
        await addToCart({
          userId: Number(userId),
          shopId: Number(shopid),
          productId: Number(item.productId),
          quantity: Number(item.quantity),
        });
      } else {
      }
    }

    clearGuestCart();
  } catch (error) {
    console.error("Error during cart migration:", error);
    throw error;
  }
};

export const loginUser = async (mobile) => {
  try {
    const formData = new FormData();
    formData.append("mobile", mobile);
    const response = await fetch(
      "https://you.strackit.com/ALUMNI/loginandsignup/loginorregistration.php",
      {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      }
    );
    const data = await response.text();
    return JSON.parse(data);
  } catch (error) {
    console.error("Login error:", error);
    return { success: false, userId: null, error: error.message };
  }
};

export const fetchUserProfile = async (mobile) => {
  try {
    const formData = new FormData();
    formData.append("mobile", mobile);

    const response = await fetch(
      "https://you.strackit.com/ALUMNI/loginandsignup/loginwithmobile.php",
      {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return null;
  }
};

export const verifyOtp = async (mobile, otp, activeUserStatus) => {
  try {
    const formData = new FormData();
    formData.append("mobile", mobile);
    formData.append("otp", otp);
    formData.append("active_user", activeUserStatus);
    const response = await fetch(
      "https://you.strackit.com/ALUMNI/loginandsignup/verifyunregistermobile.php",
      {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      }
    );
    let data = await response.text();
    data = JSON.parse(data);
    if (data.otp_verification == 0) {
      return { success: false, userId: null, error: "Invalid OTP" };
    }
    else {
      let userData;
      try {
        userData = JSON.parse(data.user);
      } catch {
        userData = null;
      }
      if (userData && Object.keys(userData).length > 0) {
        Cookies.set("ualum", JSON.stringify(userData));
        const userId = getUserId?.() || null;
        return { success: true, userId, data: userData };
      }
      return { success: false, userId: null, error: "Invalid OTP" };
    }
  } catch (error) {
    console.error("OTP verification error:", error);
    return { success: false, userId: null, error: error.message };
  }
};

export const getUserData = () => {
  try {
    const cookieValue = Cookies.get("ualum");
    if (!cookieValue) return null;

    const userData = JSON.parse(cookieValue);
    return {
      id: userData.user_id || null,
      username: userData.user_name || null,
      email: userData.email || null,
      mobile: userData.mobile || null,
    };
  } catch (error) {
    console.error("Error reading user data:", error);
    return null;
  }
};

export const registerUser = async (userData) => {
  try {
    const response = await fetch(
      "https://you.strackit.com/ALUMNI/loginandsignup/signup.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(userData),
      }
    );
    const data = await response.text();
    return data;
  } catch (error) {
    console.error("Registration error:", error);
    return null;
  }
};

export const logoutUser = () => {
  Cookies.remove("ualum");
  window.location.reload();
};
